export const insufficientPointSheet = {
  title: "ポイントが不足しています",
  balanceLabel: "所持ポイント",
  neededLabelLive: "視聴に必要",
  neededLabelCall: "通話に必要",
  neededLabel: "必要",
  unitPerMin: "pt/分",
  chargeSuffix: "でチャージ",
  payNote: "アプリ内課金でお支払い",
  doneTitle: "チャージ完了！",
  doneDesc: (args: { point: string | number }) =>
    `${args.point}ptを獲得しました`,
} as const;
